<template>
  <div class="bi-control-panel-tab">
    <BIParametersFilter />
    <BIParameterTable :can-edit="canEdit" />
  </div>
</template>
<script>
import BIParametersFilter from '@/components/BIControlPanel/BIParametersFilter.vue';
import BIParameterTable from '@/components/BIControlPanel/BIParametersTable.vue';

export default {
  name: 'BIParametersTab',
  components: { BIParametersFilter, BIParameterTable },
  props: {
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
